import axios from "axios";
import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const useAxios = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  const getValidAccessToken = async () => {
    let token = user?.accessToken;

    if (!token) return null;

    const decoded = jwtDecode(token);

    if (decoded.exp < Date.now() / 1000) {
      try {
        const { data } = await axios.get("/api/refresh", { withCredentials: true });
        setUser(prev => ({ ...prev, accessToken: data.accessToken }));
        token = data.accessToken;
      } catch (err) {
        setUser(null);
        navigate("/login");
        return null;
      }
    }

    return token;
  };

  const fetchData = async (params) => {
    setLoading(true);
    setError(null);

    try {
      const token = await getValidAccessToken();
      if (!token) return;

      const result = await axios.request({
        ...params,
        headers: { Authorization: `Bearer ${token}` },
      });

      setResponse(result.data);
    } catch (err) {
      if (err.response?.status === 401) {
        setUser(null);
        navigate("/login");
      }
      setError(err.response?.data?.message || "Request failed");
    } finally {
      setLoading(false);
    }
  };

  return { response, error, setError, loading, fetchData };
};

export default useAxios;
